module.exports = __webpack_public_path__ + "img/Mask Group 85.d3861152.png";